// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentBlockImportant_container__rfdeh","description":"ContentBlockImportant_description__j6b3a"};